import React, { useEffect } from "react";
import "./webinar.css";
import Header from "../header/header";
import Footer from "../footer/footer";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
function Webinar() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
  return (
    <>
      <Header></Header>
      <div className="webinar-image">
        {" "}
        <h6 className="webinar-bannerStyle ">Webinars</h6>
      </div>
      <Footer></Footer>
    </>
  );
}
export default Webinar;
